module.exports = __webpack_public_path__ + "img/google-webdev.1efe3ee5.svg";